import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import ToolResearchWorkflow from './pages/ToolResearchWorkflow';
import MultiAgentWorkflow from './pages/MultiAgentWorkflow';
import History from './pages/History';

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-gray-50">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/workflows" element={<Navigate to="/" replace />} />
            <Route path="/workflows/tool-research" element={<ToolResearchWorkflow />} />
            <Route path="/workflows/multi-agent" element={<MultiAgentWorkflow />} />
            <Route path="/history" element={<History />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
